import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReaderDocument } from '@narravero/web-reader-lib';
import { buildReaderDocument } from '../pass-templates/build-reader-document';
import { IChildPageLinkOption, IWidgetAnchorOption, deepCopy } from 'na-lib';
import { Template } from 'na-lib';
import { widgetTypes } from 'na-lib';
import { FormBuilder, FormGroup } from '@angular/forms';
import { languagesList, languagesList_ } from 'na-lib';
import { SettingsService } from '../../service/settings.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslationsDPPService } from '../../service/translations-dpp.service';
import { TranslateService } from '@ngx-translate/core';
import { WidgetEditDialogComponent } from 'src/app/widgets/widget-edit-dialog/widget-edit-dialog.component';
import { ITranslateWidgetData, defaultColorsValues, defaultColorsValuesDark, widgetEditMode, widgetsTranslationsFields, widgetsWithTranslations } from 'na-lib/dist/network/widgets.dto';
import { ImageEditFormComponent } from 'src/app/widgets/edit-dialog/image-edit-form/image-edit-form.component';
import { CalltoactionEditFormComponent } from 'src/app/widgets/edit-dialog/calltoaction-edit-form/calltoaction-edit-form.component';
import { BillboardVdEditFormComponent } from 'src/app/widgets/edit-dialog/billboard-vd-edit-form/billboard-vd-edit-form.component';
import { TextEditFormComponent } from 'src/app/widgets/edit-dialog/text-edit-form/text-edit-form.component';
import { ImagesEditFormComponent } from 'src/app/widgets/edit-dialog/images-edit-form/images-edit-form.component';
import { ProductRegistrationEditFormComponent } from 'src/app/widgets/edit-dialog/product-registration-edit-form/product-registration-edit-form.component';
import { VideoEditFormComponent } from 'src/app/widgets/edit-dialog/video-edit-form/video-edit-form.component';
import { SplashVideoEditFormComponent } from 'src/app/widgets/edit-dialog/splash-video-edit-form/splash-video-edit-form.component';
import { BillboardImgEditFormComponent } from 'src/app/widgets/edit-dialog/billboard-img-edit-form/billboard-img-edit-form.component';
import { DppThemeService } from 'src/app/service/dpp-theme.service';

@Component({
    selector: '[app-pass-templates-translations]',
    templateUrl: './pass-templates-translations.component.html',
    styleUrls: ['./pass-templates-translations.component.css'],
    standalone: false
})

export class PassTemplatesTranslationsComponent implements DoCheck {
  @Input('app-pass-templates-translations') data:any
  @Output() returnChangesTranslations = new EventEmitter<{state: any, changes:boolean, translations:any}>()
  formData:any
  languagesPassList:any
  allWidgets:any
  readerDocument: ReaderDocument | null = null;
  private readerDocumentSignature = '';
  templateData:any
  passTemplateLanguages:any = []
  passTemplateLanguagesO:any = {}
  darkMode = false
  phoneFullHeightView = false
  idToShow:any
  widgetsNames = widgetTypes
  themeData:any
  languagesList = languagesList
  languageSelected:any
  contextLanguages:any=[]
  contextFirstLanguage:any
  passFirstLanguage:any
  passLanguages:any=[]
  templateForm!:FormGroup
  translationForm!:FormGroup
  changesToSave=false
  contentTypeId:any
  oldTranslations:any
  languagesToTranslate:any
  oldTemplateData:any
  defaultColorsValues = defaultColorsValues
  defaultColorsValuesDark = defaultColorsValuesDark
  widgetsWithTranslations = widgetsWithTranslations

  widgetsTranslationsFields=widgetsTranslationsFields

  widgetAnchorOptions_:IWidgetAnchorOption[] = []
  childPageLinkOptions_:IChildPageLinkOption[] = []
  activeTabId:string

  constructor(private fb : FormBuilder,
    private settingsService:SettingsService,
    public dialog: MatDialog,
    private dppTranslations:TranslationsDPPService,
    private translateService: TranslateService,
    private dppThemeService: DppThemeService
    ){
      const currentLang = this.translateService.currentLang() ?? 'en';
      this.languagesList = deepCopy(languagesList_[currentLang])

      this.translateService.onLangChange.subscribe( value => {
        const currentLang = value.lang
        this.languagesList = deepCopy(languagesList_[currentLang])
      })
    }
  
  ngOnInit(): void {
    this.contextLanguages = deepCopy(this.settingsService.languagesContexts$)
    this.languagesPassList = deepCopy(this.contextLanguages)
    this.contextFirstLanguage = this.settingsService.firstLanguageContexts$

    this.formData=deepCopy(this.data[0])
    this.templateData = new Template
    this.templateData.setFromAny(this.formData)
    this.passTemplateLanguages.push(this.formData)
    this.passTemplateLanguagesO['default']= deepCopy(this.formData)

    this.translationForm = this.fb.group({
      translations: [],
      selectedLanguage:[],
      widgetsWithTranslations:[],
      widgetDefaultLanguage:[]
    })

    this.initializeForms()

    this.oldTemplateData=deepCopy(this.data[1])
    this.languagesPassList = deepCopy(this.data[3])

    this.contentTypeId = deepCopy(this.data[4])
    this.idToShow = deepCopy(this.data[5])
    this.passFirstLanguage = deepCopy(this.data[6])//defaultLanguage

    this.widgetAnchorOptions_ = deepCopy(this.data[7])
    this.childPageLinkOptions_ = deepCopy(this.data[8])
    this.activeTabId = deepCopy(this.data[9])

    if(this.formData.widgets){
      this.allWidgets = deepCopy(this.formData.widgets)
      this.translationForm.patchValue({widgetsWithTranslations : this.allWidgets})
      this.translationForm.patchValue({widgetDefaultLanguage : this.allWidgets})
    }
    
    if(this.formData.theme)
      this.themeData = this.formData.theme

    if(this.formData.translations){
      this.oldTranslations = deepCopy(this.formData.translations)
      this.translationForm.patchValue({translations : this.formData.translations ? this.formData.translations : {}})
    }

    if(this.dppTranslations.firstLanguage$.value){
      this.passFirstLanguage = this.dppTranslations.firstLanguage$.value
    }
    

    if(this.languagesPassList && this.languagesPassList.length>0){
      this.passFirstLanguage = this.languagesPassList[0]
      this.languageSelected = this.languagesPassList[1]
      this.changePassLanguage(this.languageSelected)
    }else{
      this.languagesPassList = this.data[2]
      if(this.languagesPassList && this.languagesPassList.length>0){
        this.passFirstLanguage = this.languagesPassList[0]
        this.languageSelected = this.languagesPassList[1]
        this.changePassLanguage(this.languageSelected)
      }
    }

    this.languagesToTranslate = deepCopy(this.languagesPassList)

    this.translationForm.get('translations').valueChanges.subscribe(value=>{
      this.loadTranslationsForSelectedLanguage(this.languageSelected,value)
    })

  }

  initializeForms(){
    this.templateForm = this.fb.group({
      contextId: [],
      id: [],
      theme: [],
      comment: [],
      name: [],
      templateName: [],
      contentType: [],
      customer: [],
      tridyId: [],
      widgets:[], 
      translations:[],
      languages:[],
      enableShoppingCart:[],
      enableCustomerLogin:[]
    })

    const {id, contextId, theme, comment, name, templateName, contentType, customer, tridyId, widgets, translations,languages,enableShoppingCart,enableCustomerLogin} = this.formData
    this.templateForm.patchValue({
      contextId: contextId ? contextId : undefined,
      id: id ? id : undefined,
      theme: theme ? theme : undefined,
      comment: comment ? comment : undefined,
      name: name ? name : undefined,
      templateName: templateName ? templateName : undefined,
      contentType: contentType ? contentType : this.contentTypeId,
      customer: customer ? customer : undefined,
      tridyId: tridyId ? tridyId : undefined,
      widgets: widgets ? widgets : undefined,
      translations: translations ? translations : undefined,
      languages:languages ? languages : undefined,
      enableShoppingCart: enableShoppingCart ? enableShoppingCart : false,
      enableCustomerLogin: enableCustomerLogin ? enableCustomerLogin : false
    })

    this.dppThemeService.setWidgetSpacingCornerRadius(theme)
    this.templateForm.valueChanges.subscribe(values=> {
      this.changesToSave=true
    })
    
  }

  addTranslations(){
    const newtranslations = deepCopy(this.translationForm.value.translations)
    // this.dppTranslations.addTranslations(newtranslation)
    this.returnChangesTranslations.emit({state: 'add', changes: this.changesToSave,translations: newtranslations})
  }

  closeTranslations(){
    const newtranslations = this.oldTranslations
    this.returnChangesTranslations.emit({state: 'cancel', changes: false,translations: newtranslations})
  }

  checkTypeNumber(el, indexWidget){
    let typeNumber = 1
    this.allWidgets.forEach((widget, index) => {
      if(index<indexWidget){
        if(widget.type == el.type){
          typeNumber ++
        }
      }
    })
    return typeNumber.toString()
  }

  // allWidgets (already translated for languageSelected) is replaced/mutated by the translation logic,
  // so rebuild the preview document only when its serialized content changes
  ngDoCheck(): void {
    const mediaContext = { passId: this.idToShow, contextId: this.settingsService.contextId$ };
    const signature = JSON.stringify([this.allWidgets, this.themeData, this.languageSelected, mediaContext]);
    if (signature === this.readerDocumentSignature) return;
    this.readerDocumentSignature = signature;
    this.readerDocument = buildReaderDocument(this.allWidgets ?? [], this.themeData, this.languageSelected, mediaContext);
  }

  changeTheme(value){///change this after change toggle dark(light)
    this.darkMode=value
    if(this.darkMode)
      this.dppThemeService.setColorsToDark(this.themeData)
    else
      this.dppThemeService.setColorsToLight(this.themeData)
    
  }

  changePassLanguage(lang){
    this.translationForm.patchValue({selectedLanguage : lang})

    this.templateData = new Template()
    this.templateData.setFromAny(this.passTemplateLanguagesO['default'])
    // this.showTranslatedPass(lang) //-----comment on 03.09 16:30
    this.loadTranslationsForSelectedLanguage(lang)

    if(!this.passTemplateLanguagesO[lang]){
      this.templateData = new Template()
      this.templateData.setFromAny(this.passTemplateLanguagesO['default'])
    }else{
      this.templateData = new Template()
      this.templateData.setFromAny(this.passTemplateLanguagesO[lang])
    }

  }
  
  showTranslatedPass(lang){//not updated with all widgets
    const copy = deepCopy(this.templateData)
    const template = new Template()
    template.setFromAny(copy)

    let teform = this.fb.group({
      contextId: [],
      id: [],
      theme: [],
      comment: [],
      name: [],
      contentType: [],
      customer: [],
      tridyId: [],
      widgets:[], 
      translations:[]
    })

    const {id, contextId, theme, comment, name, contentType, customer, tridyId, widgets, translations} = template
    teform.patchValue({
      contextId: contextId ? contextId : undefined,
      id: id ? id : undefined,
      theme: theme ? theme : undefined,
      comment: comment ? comment : undefined,
      name: name ? name : undefined,
      contentType: contentType ? contentType : undefined,
      customer: customer ? customer : undefined,
      tridyId: tridyId ? tridyId : undefined,
      widgets: widgets ? widgets : undefined,
      translations: translations ? translations : undefined
    })
    this.languageSelected = lang
      if(this.templateData.translations && this.templateData.translations[lang] ){
        const entries = Object.entries(this.templateData.translations[lang])
        
        entries.forEach( translation => {
          const idField = translation[0].split(".")
          const id = idField[0]
          const field = idField[1]
          const value = translation[1]

          if(teform.value.widgets && value){
            const widgets = deepCopy(teform.value.widgets)
            widgets.forEach( (widget, index) => {
              if(id == widget['id']){
                widget[field] = value
              }

              if(id.includes(widget['id']+'_')){
                if(widget['type']=="annotatedMap"){
                  if(widget['annotations']){
                    const annotations = widget['annotations']
                    annotations.forEach((annotation, index) => {
                      if(id == widget['id']+'_'+annotation.id){
                        if(annotation.dynamic){
                          const propertiesField = idField[idField.length-1]
                          if(annotation.properties)
                            annotation.properties[propertiesField] = value
                        }
                        else
                        annotation[field] = value
                      }
                    });
                  }
                }

                if(widget['type'] == 'buttons'){
                  const buttons = widget['buttons']
                  if(buttons){
                    buttons.forEach((btn, indexBTN) => {
                      if(id == widget['id']+'_'+btn.id){
                        // if(btn[field])
                          btn[field] = value
                      }
                    });
                  }
                }
              }
            })
            teform.patchValue({widgets: widgets})
            this.allWidgets = widgets
          }
        })
        
        if(!this.passTemplateLanguagesO[lang])
          this.passTemplateLanguages.push(teform.value)
        this.passTemplateLanguagesO[lang]=teform.value
      }else{

        if(teform.value.widgets){
          const widgets = deepCopy(teform.value.widgets)
         
          teform.patchValue({widgets: widgets})
          this.allWidgets = widgets
        }
        this.passTemplateLanguages.push(teform.value)
        this.passTemplateLanguagesO[lang]=teform.value
      }

    this.translationForm.patchValue({widgetsWithTranslations : this.allWidgets})
  }

  onLanguageEditor(widget, index){
    if(this.translationForm.value.selectedLanguage && this.translationForm.value.selectedLanguage != this.passFirstLanguage){
      const widgetDefaultLanguage  = this.formData?.widgets[index]

      if(this.widgetsTranslationsFields && this.widgetsTranslationsFields[widget.type]){
        let alltranslationsWidget = {}
        let translationsWidget
        
        if(this.translationForm.value.translations)
          translationsWidget = Object.keys(this.translationForm.value.translations) 
        else
          translationsWidget = []
        
  
        if(this.languagesPassList)
          translationsWidget=this.languagesPassList
  
        if(translationsWidget.length!=0){
          translationsWidget.forEach(lang => {
            if(lang == this.translationForm.value.selectedLanguage){
              if(this.translationForm.value.translations){
                if(this.translationForm.value.translations[lang]){
                  let entries = Object.entries(this.translationForm.value.translations[lang]);
                  entries.forEach( ent => {
                    if(ent[0].includes(widget.id)){
                      const key = lang+ "." + ent[0]
                      alltranslationsWidget[key] = ent[1]
                    }
                  })
                }
              }
            }
          })          
        }

  
    //----------------------------------------------
        let dialogRef
        let dialogName
        let data:any = {
          translateMode:true,
          widgetId: widget.id,
          values: widget,

          translateData: {
            translations: this.translationForm.value.translations,
            fields: this.widgetsTranslationsFields[widget.type],
            columns: this.widgetsWithTranslations[widget.type],//['title', 'subtitle','text'],
            values: widget,
            type: widget.type,
            valuesTranslated: alltranslationsWidget,
            languages: translationsWidget,
            selectedLanguage:this.translationForm.value.selectedLanguage,
            oldTemplateData:this.oldTemplateData,
            passId: this.idToShow,
            contentTypeId: this.contentTypeId,
            widget:index,
            defaultLanguageWidgetData: widgetDefaultLanguage
          }
          
        }

        let sharedData: widgetEditMode= {//widgetTranslationModeData
          translateMode:true,
          translations: this.translationForm.value.translations,
          type: widget.type,
          languages: translationsWidget,
          contentTypeId: this.contentTypeId,
          widget:index,
          defaultLanguage: this.passFirstLanguage,
          widgetId: widget.id,
          passId: this.idToShow,
          values: widgetDefaultLanguage,


          translateData: {
            originalLanguageData:false,
            dragFileData:undefined,
            dragFileDataOriginal:undefined,

            fields: this.widgetsTranslationsFields[widget.type],
            columns: this.widgetsWithTranslations[widget.type],
            values: widget,
            valuesTranslated: alltranslationsWidget,
            selectedLanguage:this.translationForm.value.selectedLanguage,
            oldTemplateData:this.oldTemplateData,
            defaultLanguageWidgetData: widgetDefaultLanguage,
          },
          anchorOptions:this.widgetAnchorOptions_,
          childPages:this.childPageLinkOptions_,
          activeTabId: this.activeTabId
        };


        switch(widget.type){
          case 'text':{
            // dialogName=TextTranslationEditComponent
            let dragFileData = {
              calledFrom: TextEditFormComponent,
              calledFromData:{
                passId: this.idToShow,
                widgetNumber:index,
                widget: "text",
              },
              enableDragDrop: false,
              enableBrowse:false,
              enableMedia:false,
              enableEnterUrl:false,
              enableMultipleDragDrop:false,
              supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
              supportedFileAccept:".jpg, .jpeg, .png, .webp",
              maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
              maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload,
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType:undefined
            }

            dialogName = WidgetEditDialogComponent//WidgetsTranslationEditComponent
            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal
            data = sharedData
            break;
          }
          case 'image':{
            dialogName = WidgetEditDialogComponent//ImageTranslationEditComponent

            let dragFileData = {
              calledFrom: ImageEditFormComponent,
              calledFromData:{
                passId: this.idToShow,
                widgetNumber:index,
                widget: "billboardImage",
              },
              enableDragDrop: true,
              enableBrowse:true,
              enableMedia:true,
              enableEnterUrl:true,
              enableMultipleDragDrop:false,
              supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
              supportedFileAccept:".jpg, .jpeg, .png, .webp",
              maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
              maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload,
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType:undefined
            }

            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal
            data = sharedData
            break;
          }
          case 'annotatedMap':{
            // dialogName = AnnotatedMapTranslationEditComponent
            dialogName = WidgetEditDialogComponent
            data = sharedData

            break;
          }
          case 'buttons':{
            // dialogName = ButtonsTranslationEditComponent

            dialogName = WidgetEditDialogComponent
            sharedData.translateData.dragFileData = undefined
            sharedData.translateData.dragFileDataOriginal = undefined
            data = sharedData

            break;
          }
          case 'billboardImage': {
            let dragFileData = {
              calledFrom: BillboardImgEditFormComponent,
              calledFromData:{
                passId: this.idToShow,
                widgetNumber:index,
                widget: "billboardImage",
              },
              enableDragDrop: true,
              enableBrowse:true,
              enableMedia:true,
              enableEnterUrl:true,
              enableMultipleDragDrop:false,
              supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
              supportedFileAccept:".jpg, .jpeg, .png, .webp",
              maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
              maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload,
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType:undefined
            }

            dialogName = WidgetEditDialogComponent

            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal

            data = sharedData
            break;
          }

          case 'billboardVideo':{
            let dragFileData = {
              calledFrom: BillboardVdEditFormComponent,
              calledFromData:{
                passId: this.idToShow,
                widgetNumber:index,
                widget: "billboardVideo",
              },
              enableDragDrop: true,
              enableBrowse:true,
              enableMedia:true,
              enableEnterUrl:true,
              enableMultipleDragDrop:false,
              supportedFileTypes:['video/*'],
              supportedFileAccept:" video/*",
              maxSizeInBytes: 25 * 1024 * 1024, // 25 MB size limit
              maxAllowedSizeInBytes: undefined, // 25 * 1024 * 1024
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType:undefined
            }

            dialogName = WidgetEditDialogComponent//WidgetsTranslationEditComponent
            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal
            data = sharedData
            break;
          }


          case 'callToAction':{
            let dragFileData = {
              calledFrom: CalltoactionEditFormComponent,
              calledFromData:{
                passId: this.idToShow,
                widgetNumber:index,
                widget: "callToAction",
              },
              enableDragDrop: true,
              enableBrowse:true,
              enableMedia:true,
              enableEnterUrl:true,
              enableMultipleDragDrop:false,
              supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
              supportedFileAccept:".jpg, .jpeg, .png, .webp",
              maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
              maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload,
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType:undefined
            }

            dialogName = WidgetEditDialogComponent//WidgetsTranslationEditComponent

            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false
            dragFileDataOriginal.enableMultipleDragDrop = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal

            data = sharedData
            break;
          }

          case 'video':{
            let dragFileData = {
              calledFrom: VideoEditFormComponent,
              calledFromData:{
                passId: this.idToShow,
                widgetNumber:index,
                widget: "video",
              },
              enableDragDrop: true,
              enableBrowse:true,
              enableMedia:true,
              enableEnterUrl:true,
              enableMultipleDragDrop:false,
              supportedFileTypes:['video/*'],
              supportedFileAccept:"video/*",
              maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
              maxAllowedSizeInBytes:undefined,
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType:undefined
            }

            dialogName = WidgetEditDialogComponent//WidgetsTranslationEditComponent
            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal
            data = sharedData
            break;
          }

          case 'splashVideo':{
            let dragFileData = {
              calledFrom: SplashVideoEditFormComponent,//TODO: change for splashVdEditFormCOmponent
              calledFromData:{
                passId: this.idToShow,
                widgetNumber: index,
                widget: "splashVideo",
              },
              enableDragDrop: true,
              enableBrowse:true,
              enableMedia:true,
              enableEnterUrl:true,
              enableMultipleDragDrop:false,
              supportedFileTypes:['video/*'],
              supportedFileAccept:"video/*",
              maxSizeInBytes: 25 * 1024 * 1024, // 25 MB size limit
              maxAllowedSizeInBytes:undefined,
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType:undefined
            }

            dialogName = WidgetEditDialogComponent//WidgetsTranslationEditComponent
            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal
            data = sharedData
            break;
          }

          case 'countdown':{
            dialogName = WidgetEditDialogComponent
            data = sharedData
            break;
          }

          case 'images':{
            dialogName = WidgetEditDialogComponent

            let dragFileData = {
              calledFrom: ImagesEditFormComponent,
              calledFromData:{
                passId: this.idToShow,
                widgetNumber:index,
                widget: "images",
                imageIndex: widget?.images?.length
              },
              enableDragDrop: true,
              enableBrowse:true,
              enableMedia:true,
              enableEnterUrl:true,
              enableMultipleDragDrop:true,
              supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
              supportedFileAccept:".jpg, .jpeg, .png, .webp",
              maxSizeInBytes:2 * 1024 * 1024, // 2 MB size limit for compression
              maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType: undefined
            }

            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal
            data = sharedData
            break;
          }

          case 'productRegistration':{
            dialogName = WidgetEditDialogComponent//WidgetsTranslationEditComponent

            let dragFileData = {
              calledFrom: ProductRegistrationEditFormComponent,
              calledFromData:{
                passId: this.idToShow,
                widgetNumber:index,
                widget: "callToAction",
              },
              enableDragDrop: true,
              enableBrowse:true,
              enableMedia:true,
              enableEnterUrl:true,
              enableMultipleDragDrop:false,
              supportedFileTypes:['image/jpeg', 'image/png', 'image/webp'],
              supportedFileAccept:".jpg, .jpeg, .png, .webp",
              maxSizeInBytes: 2 * 1024 * 1024, // 2 MB size limit for compression,
              maxAllowedSizeInBytes:20 * 1024 * 1024, // 20 MB size limit for direct upload,
              returnSupportUrl: undefined,
              returnUrlData: undefined,
              enterUrl:false,
              returnUrlType:undefined
            }

            let dragFileDataOriginal = deepCopy(dragFileData)
            dragFileDataOriginal.enableDragDrop = false
            dragFileDataOriginal.enableBrowse = false
            dragFileDataOriginal.enableMedia = false
            dragFileDataOriginal.enableEnterUrl = false

            sharedData.translateData.dragFileData = dragFileData
            sharedData.translateData.dragFileDataOriginal = dragFileDataOriginal
            data = sharedData
            break;
          }

          case 'form':{
            dialogName = WidgetEditDialogComponent

            data = sharedData
            break;
          }

          case 'composed':{
            dialogName = WidgetEditDialogComponent
            data = sharedData
            break;
          }
        }
        
        dialogRef = this.dialog.open(dialogName, {
          data:data,
          panelClass: 'custom-dialog-container',
          minWidth: '600px',
          position: { right: '0'},
          enterAnimationDuration: '200ms',
          exitAnimationDuration: '200ms'
        });
        dialogRef.afterClosed().subscribe(result =>{
          if(result[1])
          this.addMoreTranslationsToThisWidgetType(result, widget.type)
        })
    //----------------------------------------------
      }
    }else{
      // console.log('not possible to add translations on default language')
    }
  }

  addMoreTranslationsToThisWidgetType(result, type){// USED to add translated values to translations field
    let newtranslations = {}
  
    if(this.translationForm.value.translations){
      newtranslations = this.translationForm.value.translations
    }

      // if(result[1]){
        const data = result[0]
        const trans = Object.entries(data)
        trans.forEach( value => {
          const key = value[0]
          const keyName = key.split(".")
          const lang = keyName[0]
          const id = keyName[1]
          const field = keyName[2]
          const tranlationField = id +"."+field
          const translatedField = key.replace(lang+'.', '')
          //------------------------widgetData on first Language translations
          // if(lang == this.firstLanguageContexts){
          //   if(this.textEditForm.value[field]){
          //     this.textEditForm.patchValue({[field]: value[1]})
          //   }
          // }
          if(value[1]){
            if(newtranslations[lang]){
              newtranslations[lang][translatedField] = value[1]
            }else{
              newtranslations[lang]= {}
              newtranslations[lang][translatedField] = value[1]
            }
          }else{

            if(newtranslations[lang]){
              newtranslations[lang][translatedField] = undefined

            }else{
              newtranslations[lang] = {}
              newtranslations[lang][translatedField] = undefined
            }
          }
        })
        this.translationForm.patchValue({translations: newtranslations})
      // }

    
  }

  loadTranslationsForSelectedLanguage(lang, formtranslations?){
    const copy = deepCopy(this.formData)// wit this.formData instead of this.templateData we are updating default language widget with translations
    const template = new Template()
    template.setFromAny(copy)

    let teform = this.fb.group({
      contextId: [],
      id: [],
      theme: [],
      comment: [],
      name: [],
      contentType: [],
      customer: [],
      tridyId: [],
      widgets:[], 
      translations:[]
    })

    const {id, contextId, theme, comment, name, contentType, customer, tridyId, widgets} = template
    let translations = this.translationForm.value.translations

    if(formtranslations)
      translations = formtranslations

    teform.patchValue({
      contextId: contextId ? contextId : undefined,
      id: id ? id : undefined,
      theme: theme ? theme : undefined,
      comment: comment ? comment : undefined,
      name: name ? name : undefined,
      contentType: contentType ? contentType : undefined,
      customer: customer ? customer : undefined,
      tridyId: tridyId ? tridyId : undefined,
      widgets: widgets ? widgets : undefined,
      translations: translations ? translations : undefined
    })

    this.languageSelected = lang
      if(translations && translations[lang] ){
        const entries = Object.entries(translations[lang])
        
        entries.forEach( translation => {
          const translationField = translation[0]
          const idField = translation[0].split(".")
          const id = idField[0]
          const field = idField[1]
          const value = translation[1]

          if(teform.value.widgets ){//&& value
            const widgets = deepCopy(teform.value.widgets)
            widgets.forEach( (widget, index) => {
              const id_ = widget.id + '_'
              if(value  ){
                if(id == widget['id'])
                  widget[field] = value
  
                if(id.includes(widget['id']+'_')){
                  if(widget.type == "annotatedMap"){
                    if(widget['annotations']){
                      const annotations = widget['annotations']
                      annotations.forEach((annotation, index) => {
                        if(id == widget['id']+'_'+annotation.id)
                        if(annotation.dynamic){
                          const propertiesField = idField[idField.length-1]
                          if(annotation.properties)
                            annotation.properties[propertiesField] = value
                        }
                        else  
                        annotation[field] = value
                      });
                    }
                  }
  
                  if(widget.type == 'buttons'){
                    const buttons = widget['buttons']
                    if(buttons){
                      buttons.forEach((btn, indexBTN) => {
                        if(id == widget['id']+'_'+btn.id){
                          // if(btn[field])
                            btn[field] = value
                        }
                      });
                    }
                  }

                  if(widget.type == 'text'){
                    const image = widget['image']
                    if(image){
                      if(id == widget['id']+'_image'){
                        image[field] = value
                      }
                    }
                  }

                  if(widget.type == 'images'){
                    const images = widget.images
                    if(images){
                      images.forEach((image, indexBTN) => {
                        if(id == widget['id']+'_'+image.id){
                          // if(btn[field])
                          image[field] = value
                        }
                      });
                    }
                  }

                  if(widget.type == 'productRegistration'){
                    if(id == widget['id'] + '_registered' ){
                      const registered = widget.registered
                      if(registered)
                        registered[field] =  value;
                    }

                    if(id == widget.id + '_unregistered' ){
                      const unregistered = widget.unregistered
                      if(unregistered)
                      unregistered[field] = value;
                    }

                    if(id == widget.id + '_image' ){
                      const image = widget.image
                      if(image)
                      image[field] = value;
                    }
                    
                  }

                  if(widget.type == 'form'){
                    const sections = widget.sections
                    if(sections){
                      sections.forEach((section, indexBTN) => {
                        if(id == widget['id']+'_'+section.id){
                          // if(btn[field])
                          section[field] = value
                        }

                        section?.fields.forEach(fieldS => {
                          if(id == widget['id'] + '_' + section.id + '_' + fieldS.id){
                            if(fieldS[field])
                            fieldS[field] = value
                          }

                          if(fieldS.type=="options"){
                            fieldS.options?.forEach((option) => {
                              if(translationField == widget.id + '_' + section.id + '_' + fieldS.id + '.options_' + option.id + '.title')
                                option.title = value
                            });
                          }
                        });
                      });
                    }
                  }

                  if(widget.type == 'composed'){
                    const content = widget.content
                    if(content){
                      content.forEach((node, indexnode) => {
                        this.loadTranslationsForComposedContent( node, id,field, value, widget['id'])
                      });
                    }
                  }
                }
              }
              
            })
            teform.patchValue({widgets: widgets})
            this.allWidgets = widgets
          }
        })
        
        if(!this.passTemplateLanguagesO[lang])
          this.passTemplateLanguages.push(teform.value)
        this.passTemplateLanguagesO[lang]=teform.value
      }else{

        if(teform.value.widgets){
          const widgets = deepCopy(teform.value.widgets)
          this.allWidgets = widgets
        }
        this.passTemplateLanguages.push(teform.value)
        this.passTemplateLanguagesO[lang]=teform.value
      }

    this.translationForm.patchValue({widgetsWithTranslations : this.allWidgets})
  }


  searchFieldInNestedArray(array: any[], field: string, value: any): any | null {
    for (const item of array) {
      if (item[field] === value) {
        return item;
      }
      for (const key in item) {
        if (Array.isArray(item[key])) {
          const result = this.searchFieldInNestedArray(item[key], field, value);
          if (result) {
            return result;
          }
        }
      }
    }
  }

  loadTranslationsForComposedContent( content, id,field, value, widgetId){
    if(content.type == 'zstack' || content.type == 'hstack' || content.type == 'vstack'){
      const children = content.children
      children.forEach(child => {
        this.loadTranslationsForComposedContent(child, id, field, value, widgetId)
      });
    }

    if(id == widgetId+ '_' + content.id + '_attributes'){
      if(content.attributes && content.attributes[field]){
        content.attributes[field] = value
      }
    }
    
  }
  
}